import React, { useState, useEffect } from 'react';
import StatsCard from './StatsCard/StatsCard';
import { useTranslation } from 'react-i18next';
import { fetchUserStats, UserStats } from '../../../../../services/statsService';
import toast from 'react-hot-toast';

const StatsCards: React.FC = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState<UserStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    const loadStats = async () => {
      try {
        const userStats = await fetchUserStats();
        setStats(userStats);
      } catch (error) {
        toast.error(t('Falha ao carregar estatísticas do usuário.'));
      } finally {
        setIsLoading(false);
      }
    };
    loadStats();
  }, [t]);

  const statsData = [
    // Card 'Buscas Realizadas Hoje' removido
    {
      titleKey: 'Leads Salvos (Total)',
      value: isLoading ? '...' : (stats?.leadsSavedTotal.toLocaleString() || '0'),
      icon: 'bookmark',
      color: 'text-[#181411] dark:text-white'
    },
    {
      titleKey: 'Leads com WhatsApp (Total)',
      value: isLoading ? '...' : (stats?.leadsWithWhatsappTotal.toLocaleString() || '0'),
      // Usando 'phone_iphone' ou 'call' para evitar o nome estranho do ícone 'whatsapp'
      icon: 'phone_iphone', 
      color: 'text-green-600 dark:text-green-400'
    },
    {
      titleKey: 'Leads Prospectados (Total)',
      value: isLoading ? '...' : (stats?.leadsProspectedTotal.toLocaleString() || '0'),
      icon: 'send',
      color: 'text-blue-600 dark:text-blue-400'
    },
    {
      titleKey: 'WhatsApp Verificados',
      value: isLoading ? '...' : `${stats?.whatsappVerifiedPercentage || 0}%`,
      icon: 'check_circle',
      color: 'text-green-600 dark:text-green-400'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
      {statsData.map((stat, index) => (
        <StatsCard
          key={stat.titleKey}
          title={t(stat.titleKey)}
          value={stat.value}
          icon={stat.icon}
          color={stat.color}
          index={index}
        />
      ))}
    </div>
  );
};

export default StatsCards;